import { TASK_PRIORITIES } from '@k-os/core';
import { usePatchTask, type TaskDto } from '../../api/tasks';
import { PickerList } from './_picker-primitives';

const PRIORITY_LABELS: Record<TaskDto['priority'], string> = {
  critical: 'Critical',
  important: 'Important',
  routine: 'Routine',
  low: 'Low',
};

export function PriorityEditor({ task, onClose }: { task: TaskDto; onClose: () => void }) {
  const patch = usePatchTask();
  return (
    <PickerList
      options={TASK_PRIORITIES.map((p) => ({ id: p, label: PRIORITY_LABELS[p] }))}
      activeId={task.priority}
      onPick={(id) => {
        patch.mutate({ id: task.id, patch: { priority: id as TaskDto['priority'] } });
        onClose();
      }}
    />
  );
}
export { PRIORITY_LABELS };
